import { combineReducers } from 'redux';
import absences from './absences';
import cart from './cart';
import courses from './courses';
import enrolments from './enrolments';
import invoices from './invoices';
import member from './member';
import permissions from './permissions';
import requests from './requests';
import settings from './settings';
import suburbs from './suburbs';
import user from './user';
import { errorMessage,
	payPalSdkLoaded,
	payPalSdkError,
	timedOut,
	timedOutLoggedOut,
	apiSending,
	covidNoticeDismissed,
	generalNoticeDismissed,
	pdfFonts,
	uMAS4MVersion } from './general';
	
export default combineReducers({
  settings,
  suburbs,
  user,
  requests,
  member,
  courses,
  cart,
  enrolments,
  invoices,
  absences,
  permissions,
  errorMessage,
  payPalSdkLoaded,
  payPalSdkError,
  timedOut,
  timedOutLoggedOut,
  apiSending,
  covidNoticeDismissed,
  generalNoticeDismissed,
  pdfFonts,
  uMAS4MVersion,
});
